import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Styles.css";

const HelpText = ({ header, text }) => {
  return (
    <Container fluid className="help-section">
      <Row className="justify-content-center align-items-center text-center">
        <Col md={10} lg={8}>
          <h1>{header}</h1>
          <p>{text}</p>
        </Col>
      </Row>
    </Container>
  );
};

export default HelpText;
